"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShaDigest = exports.Hash = void 0;
var buffer_1 = require("buffer");
var js_sha3_1 = require("js-sha3");
var ContractId_1 = require("./ContractId");
var PublicKey_1 = require("../Crypto/PublicKey");
var Asset_1 = require("./Asset");
var BigInteger = require("bigi");
var Hash = /** @class */ (function () {
    function Hash(hash) {
        this.hash = hash;
        this.bytes = buffer_1.Buffer.from(this.hash, 'hex');
    }
    Hash.read = function (buffer, offset) {
        var bytes = buffer.slice(offset, offset + 32);
        var hash = new Hash(bytes.toString('hex'));
        return { hash: hash, offset: offset + 32 };
    };
    Hash.toBytes = function (hash) {
        return hash.bytes.toString('hex');
    };
    Hash.fromBytes = function (bytes) {
        return new Hash(bytes);
    };
    Hash.fromBuffer = function (bytes) {
        return new Hash(bytes.toString('hex'));
    };
    Hash.compute = function (bytes) {
        return new Hash(js_sha3_1.sha3_256(bytes));
    };
    Hash.joinHashes = function (bytes) {
        return Hash.computeMultiples(bytes.map(function (hash) { return hash.hash; }));
    };
    Hash.computeMultiples = function (bytes) {
        return new Hash(js_sha3_1.sha3_256(buffer_1.Buffer.from(bytes.join(''), "hex")));
    };
    Hash.zero = function () {
        return new Hash('0000000000000000000000000000000000000000000000000000000000000000');
    };
    Hash.updateString = function (string) {
        return Hash.fromHasher(ShaDigest.updateString(string));
    };
    Hash.updatePublicKey = function (pk) {
        return Hash.fromHasher(ShaDigest.updatePublicKey(pk));
    };
    Hash.updateContractId = function (contractId) {
        return Hash.fromHasher(ShaDigest.updateContractId(contractId));
    };
    Hash.updateU32 = function (bigi) {
        return Hash.fromHasher(ShaDigest.updateU32(BigInteger.valueOf(bigi)));
    };
    Hash.updateU64 = function (bigi) {
        return Hash.fromHasher(ShaDigest.updateU64(BigInteger.valueOf(bigi)));
    };
    Hash.updateAsset = function (asset) {
        return Hash.fromHasher(ShaDigest.updateAsset(asset));
    };
    Hash.updateHash = function (hash) {
        return Hash.fromHasher(ShaDigest.updateHash(hash));
    };
    Hash.fromHasher = function (hasher) {
        return Hash.fromBuffer(buffer_1.Buffer.from(hasher.toString(), "hex"));
    };
    Hash.fromBigi = function (bigi) {
        return Hash.fromBuffer(bigi.toBuffer(32));
    };
    Hash.prototype.toBytes = function () {
        return this.bytes.toString('hex');
    };
    Hash.prototype.computeOfHash = function () {
        return Hash.compute(this.hash);
    };
    Hash.prototype.isValid = function () {
        return this.getSize() === this.bytes.length;
    };
    Hash.prototype.getSize = function () {
        return 32;
    };
    Hash.prototype.write = function (buffer, offset) {
        this.bytes.copy(buffer, offset);
        return offset + 32;
    };
    Hash.prototype.toJson = function () {
        return { hash: this.hash };
    };
    Hash.prototype.toString = function () {
        return this.hash;
    };
    Hash.prototype.toBigi = function () {
        return BigInteger.fromBuffer(this.bytes);
    };
    return Hash;
}());
exports.Hash = Hash;
var ShaDigest;
(function (ShaDigest) {
    function updateU32(bigi, s) {
        var hasher = s || js_sha3_1.sha3_256;
        if (typeof bigi === 'string')
            bigi = new BigInteger(bigi, 10, undefined);
        else if (typeof bigi === "number")
            bigi = BigInteger.valueOf(bigi);
        if (!bigi)
            return hasher.update('');
        return hasher.update(bigi.toBuffer(4));
    }
    ShaDigest.updateU32 = updateU32;
    function updateU64(bigi, s) {
        var hasher = s || js_sha3_1.sha3_256;
        if (typeof bigi === 'string')
            bigi = new BigInteger(bigi, 10, undefined);
        else if (typeof bigi === "number")
            bigi = BigInteger.valueOf(bigi);
        if (!bigi)
            return hasher.update('');
        return hasher.update(bigi.toBuffer(8));
    }
    ShaDigest.updateU64 = updateU64;
    function updateHash(hash, s) {
        var hasher = s || js_sha3_1.sha3_256;
        return hasher.update(hash.bytes);
    }
    ShaDigest.updateHash = updateHash;
    function updateAsset(asset, s) {
        var internalAsset;
        if (asset instanceof Asset_1.Asset)
            internalAsset = asset;
        else
            internalAsset = new Asset_1.Asset(asset);
        return updateHash(new Hash(internalAsset.getSubType()), updateContractId(internalAsset.toContractId(), s));
    }
    ShaDigest.updateAsset = updateAsset;
    function updateContractId(cid, s) {
        var contractId;
        if (cid instanceof ContractId_1.ContractId)
            contractId = cid;
        else
            contractId = ContractId_1.ContractId.fromString(cid);
        return updateHash(contractId.cHash, updateU32(contractId.getVersionBigi(), s));
    }
    ShaDigest.updateContractId = updateContractId;
    function updateString(str, s) {
        var hasher = s || js_sha3_1.sha3_256;
        if (!str)
            return hasher.update('');
        return hasher.update(str);
    }
    ShaDigest.updateString = updateString;
    function updatePublicKey(pk, s) {
        var publicKey;
        if (pk instanceof PublicKey_1.PublicKey)
            publicKey = pk;
        else
            publicKey = PublicKey_1.PublicKey.fromString(pk);
        var hasher = s || js_sha3_1.sha3_256;
        return hasher.update(publicKey.serialize());
    }
    ShaDigest.updatePublicKey = updatePublicKey;
})(ShaDigest = exports.ShaDigest || (exports.ShaDigest = {}));
//# sourceMappingURL=Hash.js.map